export default __webpack_public_path__ + "static/media/card-text.07d7fb9b.svg";